module.exports = __webpack_public_path__ + "static/media/Lato-Bold.eb953203.ttf";